module.exports = __webpack_public_path__ + "img/user.7be01466.svg";